import { IHrDepartmentState } from '@/store/hr-department';
import { IHrDepartmentGetters } from './getters.types';
import { IHrDepartment, HrDepartment } from '@/models';

export const getters: IHrDepartmentGetters = {
  getHrDepartments(state: IHrDepartmentState): IHrDepartment[] {
    return state.hrDepartments.map(data => new HrDepartment(data));
  },

  getHrDepartmentById: (state: IHrDepartmentState) => (
    id: number
  ): IHrDepartment | undefined => {
    const data = state.hrDepartments.find(
      hrDepartment => hrDepartment.id === id
    );
    if (!data) {
      return undefined;
    }

    return new HrDepartment(data);
  }
};
